module.exports = __webpack_public_path__ + "static/media/Submarine_start.865fa971.mp4";